import { render } from "./SaleCustomersTab.vue?vue&type=template&id=21bcafde&scoped=true"
import script from "./SaleCustomersTab.vue?vue&type=script&lang=js"
export * from "./SaleCustomersTab.vue?vue&type=script&lang=js"

import "./SaleCustomersTab.vue?vue&type=style&index=0&id=21bcafde&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21bcafde"]])

export default __exports__